// @ts-check

// Import from MUI v5
import hexToRGBA from '../util/HEXToRGBA';
import { createTheme } from '@mui/material/styles';

const defaultThemeFont = createTheme({
  typography: {
    fontFamily: [
      'articulat-cf',
      'Arial',
      'sans-serif', // Fallback fonts
    ].join(','),
  },
});

const theme = createTheme(defaultThemeFont, {
  palette: {
    // Define custom colors or use the defaults
    success: {
      main: '#98CE00',
      light: '#81c784',
    },
    error: {
      main: '#f44336',
      light: '#e57373',
    },
    info: {
      dark: '#01579B',
      main: '#0288D1',
      light: '#2196F3',
    },
    grey: {
      main: '#E8EAEE',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
  },
});

export const themeV5 = createTheme(theme, {
  palette: {
    focused: theme.palette.augmentColor({
      color: {
        main: hexToRGBA(theme.palette.info.light, '.30'),
      },
      name: 'focused',
    }),
  },
  // Your MUI v5 theme settings here
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          textTransform: 'capitalize',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          margin: '4px',
          fontSize: '14px',
          lineHeight: '18px',
          color: theme.palette.info.dark,
          border: `1px solid ${theme.palette.info.main}`,
          '&.MuiChip-colorDefault': {
            backgroundColor: theme.palette.common.white,
            '&:hover': {
              backgroundColor: hexToRGBA(theme.palette.info.light, '.30'),
            },
          },
          '&.MuiChip-colorSuccess': {
            backgroundColor: hexToRGBA(theme.palette.success.main, '.30'),
            '&:hover': {
              backgroundColor: hexToRGBA(theme.palette.success.main, '.40'),
            },
          },
          '& .MuiChip-deleteIcon': {
            color: hexToRGBA(theme.palette.info.main, '.75'),
            '&:hover': {
              color: hexToRGBA(theme.palette.info.main, '.75'),
            },
          },
          '& .MuiChip-label': {
            padding: '0 10px',
          },
        },
        deletable: {
          '&:focus': {
            backgroundColor: hexToRGBA(theme.palette.info.light, '.30'),
          },
        },
      },
    },
  },
});
